import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface OptionProps {
  disabled?: boolean;
  height?: number;
}

const ITEM_HEIGHT = 44;

export const CreatableSelectOption = styled.span<OptionProps>`
  display: flex;
  flex-shrink: 0;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 0 ${toRem(theme.space.xs)};
  background-color: ${theme.color.white};
  color: ${theme.color.neutral[900]};
  cursor: pointer;

  &:hover {
    div {
      background-color: ${theme.color.neutral[50]};
    }
  }

  &.active {
    div {
      background-color: ${theme.color.neutral[50]};
      font-weight: ${theme.font.weight.medium};
    }
  }

  div {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    max-width: 100%;
    height: ${({ height }) => (height ? toRem(height) : toRem(ITEM_HEIGHT))};
    min-height: ${({ height }) => (height ? toRem(height) : toRem(ITEM_HEIGHT))};
    padding: 0 ${toRem(theme.space.md)};
    border-radius: ${toRem(5.5)};
    background-color: transparent;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      color: ${theme.color.neutral[400]};
      cursor: default;

      &:hover {
        div {
          background-color: ${theme.color.white};
          color: ${theme.color.neutral[400]};
        }
      }
    `}
`;
